/**
 * Topbar — persistent header above the shell that surfaces the
 * current project. Renders a clearly-visible project picker so the
 * tenant scope is never ambiguous (every /api/v2/* call is scoped by
 * the selection, so the user needs to see what they're looking at).
 *
 * CSS: styles/components/topbar.css
 */

/**
 * Render the topbar HTML. The `<select id="project-picker">` is the
 * canonical DOM element that `initProjects()` in src/project.ts
 * populates — keep the id stable or that wiring breaks.
 *
 * `window.onProjectSwitch` is exposed by app.ts and bound via
 * `onchange`; keeping this as an inline handler (rather than a
 * delegated action) mirrors how native `<select>` change events
 * interact with keyboard users most predictably.
 */
export function renderTopbar(): string {
  return `<header class="topbar" role="banner">
    <div class="topbar-inner">
      <span class="topbar-brand" aria-hidden="true">&#x1F43B; grizzly</span>
      <div class="topbar-project">
        <label class="topbar-label" for="project-picker">Project</label>
        <select
          id="project-picker"
          class="topbar-picker"
          aria-label="Select project"
          onchange="window.onProjectSwitch(this.value)"
        >
          <option value="">Loading projects&hellip;</option>
        </select>
      </div>
    </div>
  </header>`
}
